<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/lodash.png" /></div>
      <p>Lodash</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/lodash/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [
        {
          label: '4.17.21',
          linkList: [
            ur + '4.17.21/lodash.js',
            ur + '4.17.21/lodash.min.js'
          ]
        },
        {
          label: '4.17.10',
          linkList: [
            ur + '4.17.10/lodash.js',
            ur + '4.17.10/lodash.min.js'
          ]
        }, {
          label: '4.17.9',
          linkList: [
            ur + '4.17.9/lodash.js',
            ur + '4.17.9/lodash.min.js'
          ]
        }, {
          label: '4.17.5',
          linkList: [
            ur + '4.17.5/lodash.js',
            ur + '4.17.5/lodash.min.js'
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListLodash.vue